import * as backend from '../backend-helpers/wallMaterials';

const GET_WARDROBE_MATERIALS_REQUEST = 'GET_WARDROBE_MATERIALS_REQUEST';
const GET_WARDROBE_MATERIALS_SUCCESS = 'GET_WARDROBE_MATERIALS_SUCCESS';
const GET_WARDROBE_MATERIALS_ERROR = 'GET_WARDROBE_MATERIALS_ERROR';

const GET_WARDROBE_MATERIAL = 'GET_WARDROBE_MATERIAL';

import {
    WALL_MATERIAL_LIKE_SUCCESS,
    WALL_MATERIAL_DENOUNCE_SUCCESS,
    WALL_MATERIAL_COMMENT_SUCCESS
} from 'reducers/wallMaterial';

const defaultState = {
    list: [],
    totalCount: null,
    offset: 0,
    isLoading: false
};

export default function wardrobeMaterials(state = defaultState, action) {
    switch (action.type) {
        case GET_WARDROBE_MATERIALS_REQUEST:
            return {
                ...state,
                isLoading: true,
                list: action.infinite ? state.list : [],
            };
        
        case GET_WARDROBE_MATERIALS_SUCCESS:
            const { list, totalCount } = action.result.data;
            let offset, newList;

            if (action.infinite) {
                newList = Array.prototype.concat(state.list, list);
                offset = action.offset + list.length;
            } else {
                newList = list;
                offset = list.length;
            }
    
            return {
                ...state,
                isLoading: false,
                list: newList,
                offset,
                totalCount
            };

        case WALL_MATERIAL_LIKE_SUCCESS:
            const { like_count } = action.result;

            if (state.list) {
                return {
                    ...state,
                    list: state.list.map((wardrobeMaterial) => wardrobeMaterial.id === action.id ? {
                        ...wardrobeMaterial,
                        like_count: like_count
                    } : wardrobeMaterial)
                }
            }

            return state;

        case WALL_MATERIAL_DENOUNCE_SUCCESS:
            const { hidden } = action.result;

            if (hidden && state.list && state.list.length) {
                let newList = state.list.filter((wardrobeMaterial) => wardrobeMaterial.id !== action.id);
    
                if (newList.length !== state.list.length) {
                    return {
                        ...state,
                        list: newList,
                        totalCount: state.totalCount - 1,
                        offset: state.offset > 0 ? state.offset - 1 : state.offset,
                    }
                }
            }
            return state;

        case WALL_MATERIAL_COMMENT_SUCCESS:
            let { comment_count } = action.result.data;

            if (state.list) {
                return {
                    ...state,
                    list: state.list.map((wardrobeMaterial) => wardrobeMaterial.id === action.id ? {
                        ...wardrobeMaterial,
                        comment_count: comment_count
                    } : wardrobeMaterial)
                }
            }
            return state;

        case GET_WARDROBE_MATERIAL:
            return {
                ...state,
                list: [ action.wardrobeMaterial, ...state.list.slice(0,-1) ]
            };

        default:
            return state;
    }
}

export const getWardrobeMaterials = ({infinite = false, ...params}) => ({
    promise: backend.getWallMaterials({...params, kind: 'wardrobe'}),
    types: [GET_WARDROBE_MATERIALS_REQUEST, GET_WARDROBE_MATERIALS_SUCCESS, GET_WARDROBE_MATERIALS_ERROR],
    infinite,
    offset: params.offset,
    kind: params.kind
});

export const getWardrobeMaterialAction = data => ({
    type: GET_WARDROBE_MATERIAL,
    wardrobeMaterial: data.wardrobeMaterial,
});



// WEBPACK FOOTER //
// ./src/reducers/wardrobeMaterials.js